import { io } from 'socket.io-client';
import { getAccess } from '../auth/storage';

export function createSocket() {
  return io('/', {
    auth: { token: getAccess() },
    autoConnect: true,
    reconnection: true,
  });
}
